<mat-accordion>
  <mat-expansion-panel #expansionPanelFilters aria-label="Filters Panel" [expanded]="true"
                       [ngClass]="{ 'sticky-panel': expansionPanelFilters.expanded }"
                       (afterCollapse)="resultsContainer.scrollTop = 0">
    <mat-expansion-panel-header>
      <mat-panel-title class="font-weight-bold">{{ type.replace('-', ' ') | titlecase }}</mat-panel-title>
      <mat-panel-description class="justify-content-end">
        <strong class="d-flex align-items-center">
          <mat-icon class="h-auto" fontSet="fas" fontIcon="fa-filter"></mat-icon>
          {{ expansionPanelFilters.expanded ? 'Hide' : 'Show' }} Filters
        </strong>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div>
      <ng-ut-filters-form-container
        [filtersSettings]="filtersConfigs"
        [filtersFormName]="gridConfigs?.gridName"
        [gridName]="gridConfigs?.gridName"
        (saveFilters)="saveFilters($event)"
        (createReport)="createReport($event)">
      </ng-ut-filters-form-container>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<div #resultsContainer class="results-container d-flex flex-column mt-1" [ngClass]="{ 'overflow-auto': !expansionPanelFilters.expanded }">
  <div class="container-fluid bg-white " *ngIf="type === metricType.REVIEW_DETENTION">
    <div class="row justify-content-end">
      <div class="col-md-3">
        <div class="row no-gutters">
          <div class="col d-flex flex-column">
            <div class="m-2 d-flex">
              <div class="legend-item type-denied mt-1"></div>
              Denied
            </div>
          </div>
          <div class="col d-flex flex-column">
            <div class="m-2 d-flex">
              <div class="legend-item type-approved mt-1"></div>
              Approved
            </div>
          </div>
          <div class="col d-flex flex-column">
            <div class="m-2 d-flex">
              <div class="legend-item type-pending mt-1"></div>
              Pending
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid px-0 flex-grow-1">
    <div class="row h-100 no-gutters">
      <ns-grid *ngIf="gridConfigs && gridInitialized"
               [name]="gridConfigs.gridName"
               [gridTitle]="gridConfigs.gridTitle"
               [rowSelection]="gridConfigs.rowSelection"
               [config]="gridConfigs.headerOptions"
               [data]="data"
               [columns]="gridConfigs.columns"
               [loading]="loading"
               [gridOptions]="gridConfigs.options"
               [autoGroupColumnDef]="gridConfigs.options.autoGroupColumnDef"
               (refresh)="emitMakeAdvanceSearch()"
               (ready)="setGrid($event)">
      </ns-grid>
    </div>
  </div>
</div>
